import type { MethodResponse } from "openapi-fetch";
import { type client, mutationOptions, queryOptions } from "../client.ts";
import type { ConsentOrigin } from "../types.ts";

export type WorkspaceConsentStatusResponse = MethodResponse<
    typeof client,
    "get",
    "/bff/auth/getWorkspaceConsentStatus"
>;

export function workspaceTenantConsentRequestTokenQueryOptions(origin?: ConsentOrigin) {
    return queryOptions(
        "get",
        "/bff/auth/getWorkspaceTenantConsentRequestToken",
        origin ? { params: { query: { origin } } } : undefined
    );
}

export function workspaceTenantReconsentRequestTokenQueryOptions() {
    return queryOptions("get", "/bff/auth/getWorkspaceTenantReconsentRequestToken");
}

export function workspaceConsentStatusQueryOptions() {
    return queryOptions("get", "/bff/auth/getWorkspaceConsentStatus");
}

export function sendConsentRequestMutationOptions() {
    return mutationOptions("post", "/bff/consent-requests");
}

export function consentRequestPendingQueryOptions(origin?: ConsentOrigin) {
    return queryOptions("get", "/bff/consent-requests/pending", origin ? { params: { query: { origin } } } : undefined);
}
